import {
  Box,
  Card,
  CardHeader,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

export default function PopularItemsCard({ title, emptyLabel, items = [] }) {
  return (
    <Card sx={{ height: "100%" }}>
      <CardHeader
        title={title}
        titleTypographyProps={{ variant: "h6" }}
        sx={{ pb: 0 }}
      />
      <Box sx={{ px: 2, pb: 2 }}>
        {items.length > 0 ? (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Value</TableCell>
                <TableCell align="right">Searches</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {items.map((item) => (
                <TableRow hover key={`${item.value}-${item.count}`}>
                  <TableCell sx={{ textTransform: "capitalize" }}>
                    {item.value}
                  </TableCell>
                  <TableCell align="right">{item.count}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : (
          <Typography color="text.secondary" sx={{ py: 2 }} variant="body2">
            {emptyLabel}
          </Typography>
        )}
      </Box>
    </Card>
  );
}
